import { ApolloProvider as BaseApolloProvider } from "@apollo/client";
import { ReactNode } from "react";
import { client } from "@/lib/apollo-client";
interface Props {
  children: ReactNode;
}
export function ApolloProvider({ children }: Props) {
  return <BaseApolloProvider client={client}>{children}</BaseApolloProvider>;
}
